import { call, put, takeEvery } from 'redux-saga/effects';
import { aiActions } from '../actions/aiActions';
import { url } from '../config';
import axios from 'axios';

function getAllChatsHistory() {
  return axios.get(url + '/api/chatbot/chat/');
}

function addChat(newChat) {
  return axios.post(url + `/api/chatbot/chat/`, newChat);
}

function deleteChat(chat_id) {
  return axios.delete(url + `/api/chatbot/chat/${chat_id}/`);
}

function* getChatHistoriesSaga() {
  try {
    const chats = yield call(getAllChatsHistory);
    yield put({
      type: aiActions.GET_CHAT_HISTORIES_SUCCESS,
      payload: chats?.data?.results,
    });
  } catch (error) {
    yield put({
      type: aiActions.GET_CHAT_HISTORIES_FAILURE,
      payload: error?.response?.data || error?.message || 'Error getting chats',
    });
  }
}

function* addChatSaga(action) {
  try {
    const response = yield call(addChat, action.payload);
    yield put({ type: aiActions.ADD_CHAT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({
      type: aiActions.ADD_CHAT_FAILURE,
      payload: error?.response?.data || error?.message || 'Error adding chat',
    });
  }
}

function* deleteChatSaga(action) {
  try {
    yield call(deleteChat, action.payload);
    yield put({
      type: aiActions.DELETE_CHAT_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    yield put({
      type: aiActions.DELETE_CHAT_FAILURE,
      payload: error?.response?.data || error?.message || 'Error deleting chat',
    });
  }
}

function* aiAPI() {
  yield takeEvery(aiActions.GET_CHAT_HISTORIES, getChatHistoriesSaga);
  yield takeEvery(aiActions.ADD_CHAT, addChatSaga);
  yield takeEvery(aiActions.DELETE_CHAT, deleteChatSaga);
}

export default aiAPI;
